// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"Typeahead_iconContainer__BZKiC"};